// Returns a comparison function for sorting an array
// of objects by key argument whose value is number.
export function getCompareFunc(key) {
    return (a, b) =>  a[key] - b[key];
}